module.exports = __webpack_public_path__ + "img/steamLogo.40d170f7.svg";